import {request} from '../helpers/request'
import React from 'react';
import ReportboxComponent from './common/ReportboxComponent';
import $ from 'jquery'
import Immutable from 'immutable'
import ModalComponent from './common/ModalComponent'
import LoadingComponent from './common/LoadingComponent'
import _ from 'lodash'
import {browserHistory} from 'react-router'
import {t} from '../helpers/translate'
import {Well} from 'react-bootstrap'
import {Button, ButtonGroup} from 'react-bootstrap'
let config = require('config');

class Report extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sources: [],
      criteria: this.getCriteriaFromQuery(this.props.location.query),
      errors: null,
      showModal: false,
      resetDataOnClose: false,
      requestStatus: true,
      processing: false
    }
  }

  componentWillMount() {
    if (!sessionStorage.getItem('auth')) {
      browserHistory.push('/')
    }
    this.loadData();
  }

  componentWillReceiveProps(newProps) {
    this.sendReport(newProps.location.query);
  }

  loadData() {
    $.when(request(`${config.default.api}/reportSources/`, 'GET', null, this.loadSources.bind(this))).done(this.updateRequestStatus.bind(this));
  }

  updateRequestStatus (){
    this.setState({requestStatus: false})
  }

  loadSources(responseData, statusCode) {
    if (statusCode == 200) {
      let temp_sources = [];
      responseData.sources.forEach(function(source) {
        temp_sources.push({
          value: source.id,
          text: `${source.full_name} ${source.category}`
        });
      });
      this.setState({
        sources: temp_sources
      });
    }
  }

  getCriteriaKeys() {
    let reports = config.default.reports['policies']['ingle'];
    reports[0]['options'] = this.state ? this.state.sources : [];

    return config.default.reports['policies']['ingle'].map((field) => field.key)
  }

  getCriteriaFromQuery(query) {
    let criteriaKeys = this.getCriteriaKeys();
    let criteria = Immutable.Map({});
    for (let key of criteriaKeys) {
      if (query[key]) {
        criteria = criteria.set(key, query[key]);
      }
    }
    return criteria.toObject();
  }

  setSearchCriteria(query) {
    this.state.criteria = this.getCriteriaFromQuery(query);
  }

  getPage() {
    return this.state.page
  }

  getRequestBody() {
    let requestBody = {
      criteria: this.state.criteria,
    };
    return requestBody
  }

  loadSearchData(responseData, statusCode) {
    this.handleResponse(responseData, statusCode)
  }

  getErrors(criteria) {
    let errors = [];
    let criteriaKeys = config.default.reports['policies']['ingle'];

    for (let [key, criteriaKey] of Object.entries(criteriaKeys)) {
      if (criteriaKey.can_be_empty !== true && criteria[criteriaKey.key] === undefined) {
        errors.push(`${t('Please enter a valid')} ${criteriaKey.as}`)
      }
    }
    
    let errorsClean = this.cleanErrors(errors);

    if (criteria.email_to && !this.validateEmail(criteria.email_to)) {
      errorsClean.push( t('Please enter a valid To email') );
    }

    if (criteria.email_cc && !this.validateEmail(criteria.email_cc)) {
      errorsClean.push( t('Please enter a valid CC email') );
    }

    if (criteria.start_date && criteria.end_date && criteria.start_date > criteria.end_date) {
      errorsClean.push( t('The End Date must be after the Start Date') );
    }

    this.setState({errors: errorsClean});
    return errorsClean;
  }

  cleanErrors(errors) {
    return errors.filter(x => x !== null);
  }

  sendReport(query) {
    this.setState({requestStatus:false});
    this.setSearchCriteria(query);

    if (this.getErrors(this.state.criteria).length == 0) {
      this.setState({processing: true});
      $.when(request(
        this.getReportUrl(),
        'POST', 
        this.getRequestBody(), 
        this.handleResponse.bind(this)
      ))
    }
  }

  validateEmail(email) {
    const format = /\S+@\S+\.\S+/;
    return format.test(email);
  }

  getReportUrl() {
    return `${config.default.api}/report/`;
  }

  showModal(title, body, resetDataOnClose = true) {
    this.setState({
        showModal: true,
        modalBody: t(body),
        modalTitle: t(title),
        resetDataOnClose: resetDataOnClose
      }
    )
  }

  handleModalClose(resetDataOnClose = true) {
    this.setState({
        showModal: false
      },
    )
  }

  handleResponse(responseData, statusCode) {
    this.setState({processing: false});
    if (statusCode == 200) {
        this.showModal(t('Success'), responseData.message, false);
    } else {
      const errorMessage = responseData.messages ? responseData.messages[0] : 'Your report has failed to send';
      this.showModal(t('Error'), errorMessage, false);
    }
  }

  resetData() {
    this.setState({
        quoteResponseData: null,
        loading: true
      }, function() {
      }
    );
    window.location.reload();
  }

  displayErrors() {
    let errors = this.state.errors;

    if (errors && errors.length > 0) {
      return (
        <div className='alert alert-danger' role='alert'>
          <div className='error-list'>
            {errors.map((error, index) => <li key={index}>{error}</li>)}
          </div>
        </div>);
    }
    return undefined;
  }

  render() {
    return (<div className="container">
      <div className="text-center bg-inherit">
        <h2 className='page-title row'>Reporting</h2>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          <h4 className="page-subtitle">{t('Enter all the criteria for the report')}</h4>
        </div>
      </div>
      
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-6">
          <div className="col-md-12 text-center">
            {this.displayErrors()}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3"></div>
        <div className="search-box col-md-6">

          <ReportboxComponent sources={this.state.sources}/>
          <br />
          <ModalComponent 
            title={this.state.modalTitle} 
            body={this.state.modalBody}
            onClose={this.handleModalClose.bind(this)} 
            show={this.state.showModal}
            resetDataOnClose={this.state.resetDataOnClose}
          />
        </div>
      </div>
      <br />
      <LoadingComponent show={this.state.processing} text='Processing Request'/>
    </div>);
  }
}

Report.defaultProps = {};

export default Report;



// WEBPACK FOOTER //
// ./src/components/Report.js